/** @jsxImportSource @emotion/react */

import Link from 'next/link';
import {Typography} from '@vc-workspace/utils-typography';
import { getFilledRange } from '@vc-workspace/utils-helpers';
import { DynamicKeySchema } from '@vc-workspace/utils-schemas';
import {useRouter} from 'next/router';
import { 
  containerStyles, 
  prevNextBtnStyles, 
  pageNumListStyles, 
  pageNumIconStyles, 
  pageNumStyles,
  selectedNumIconStyles,
  disabledPrevNextBtnStyles
 } from './style';

export const DEFAULT_PAGINATION_LIMIT = 30;
const MAX_DISPLAYED_PAGE_COUNT = 10;
/* eslint-disable-next-line */
export interface PaginationProps {
  totalCount: number,
  currentPage: number,
  paginationLimit?: number,
  pathname: string,
  query?: DynamicKeySchema
}

export function Pagination(props: PaginationProps) {

  const router = useRouter();

  let paginationLimit = DEFAULT_PAGINATION_LIMIT

  if(props.paginationLimit) {
    paginationLimit = props.paginationLimit
  }

  const totalPages = Math.ceil(props.totalCount/paginationLimit)

  if(totalPages < 2) {
    return null
  }

  let start = props.currentPage;
  let end = props.currentPage;
  let pagesCount = 1;
  let newPagesCount = 1;

  while(pagesCount < MAX_DISPLAYED_PAGE_COUNT)
  {
    if (end + 1 <= totalPages)
    {
        // Ok to take one more page towards end
      end++;
      newPagesCount++;
    }
    if(start - 1 > 0)
    {
      //Ok to take one more page towards start
      start--;
      newPagesCount++;
    }
    /* 
      Break loop if no additional pages were 
      obtained in this iteration
      We have obtained maximum number of possible pages
    */
    if (newPagesCount === pagesCount)
      break;
    else
      pagesCount = newPagesCount;
  }

  function onPrevClick() {
    if(props.currentPage !== 1) {
      router.push({
        pathname: props.pathname,
        query: {
          ...props.query,
          'page': props.currentPage - 1
        }
      })
    }
  }

  function onNextClick() {
    if(props.currentPage !== totalPages) {
      router.push({
        pathname: props.pathname,
        query: {
          ...props.query,
          'page': props.currentPage + 1
        }
      })
    }
  }

  return (
    <div css={containerStyles}>
      <Typography
        type="SubHeading1"
        color={props.currentPage === 1 ? "shady_lady" :"valhalla"}
        custom_style={[prevNextBtnStyles, props.currentPage === 1 ? disabledPrevNextBtnStyles : null]}
        onClick={onPrevClick}
        inline
        semi_bold>
          Previous
      </Typography>
      <div css={pageNumListStyles}>
        {
          getFilledRange(start, end).map(item => (
            <Link
              key={item}
              href={{
                pathname: props.pathname,
                query: {...props.query, 'page': item}
              }}>
              <div key={item} css={[pageNumIconStyles, props.currentPage === item ? selectedNumIconStyles : null]}>
                <Typography
                  type="Headline_H2"
                  color={props.currentPage === item ? "white" : "valhalla"}
                  hover_color={"white"}
                  custom_style={pageNumStyles}
                  inline
                  semi_bold>
                  {item}
                </Typography>
              </div>
            </Link>
          ))
        }
      </div>
      <Typography
        type="SubHeading1"
        color={props.currentPage === totalPages ? "shady_lady" :"valhalla"}
        custom_style={[prevNextBtnStyles, props.currentPage === totalPages ? disabledPrevNextBtnStyles : null]}
        onClick={onNextClick}
        inline
        semi_bold>
          Next
      </Typography>
    </div>
  );
}
